module.exports = __webpack_public_path__ + "static/media/amsh-how-it-works-bg.8165cfea.svg";